import { cn } from "@/lib/cn";
import type { DomainStatus, RunStatus } from "@/api/types";

type Status = DomainStatus | RunStatus | string;

const TONE: Record<string, string> = {
  // run statuses
  running: "badge-accent",
  paused: "badge-warn",
  complete: "badge-success",
  failed: "badge-danger",
  cancelled: "badge-warn",
  // domain statuses
  pending: "badge",
  extracted: "badge-success",
  skipped: "badge",
  unreachable: "badge-unreachable",
  error: "badge-danger",
  ignored: "badge",
};

// Hover-tooltip fallback when the caller doesn't supply a `title`. Keeps
// the badge useful on its own for the two domain statuses where the
// underlying error info either lives in a different field (`error`'s
// details are in the events log, not on the row) or covers a benign
// case the user may not recognise on sight.
const DEFAULT_TITLE: Record<string, string> = {
  unreachable: "Target server didn't respond — DNS, network, TLS, or wall-clock timeout. Not an application bug.",
  error: "Internal failure during extraction — see events log for details.",
};

export function StatusBadge({
  status,
  className,
  title,
}: {
  status: Status;
  className?: string;
  title?: string;
}) {
  const tone = TONE[status] ?? "badge";
  const effectiveTitle = title ?? DEFAULT_TITLE[String(status)];
  return (
    <span className={cn(tone, className)} title={effectiveTitle}>
      {status}
    </span>
  );
}
